import { Button } from '@design/components/button/Button';
import { CheckBox } from '@design/components/checkbox/CheckBox';
import { highlight } from '@helpers';
import { useTranslation } from 'react-i18next';

import { RegionState } from '../utils';
import styles from './FollowRegionRow.module.scss';

export interface FollowRegionRowProps {
  regionCode: string;
  regionName: string;
  countryCount: number;
  state: RegionState;
  expandable?: boolean;
  isExpanded?: boolean;
  onToggle: () => void;
  onExpandToggle?: () => void;
  highlighted?: string;
}

/**
 * @deprecated
 */
export const FollowRegionRow = ({
  regionCode,
  regionName,
  countryCount,
  state,
  expandable = true,
  isExpanded = false,
  onToggle,
  onExpandToggle,
  highlighted,
}: FollowRegionRowProps) => {
  const { t } = useTranslation('onboarding');

  const displayName = highlighted
    ? highlight(regionName, highlighted)
    : regionName;

  return (
    <div
      className={styles.row}
      data-testid={`follow-region-row-${regionCode}`}
      data-region-state={state}
    >
      <div className={styles.checkboxAndLabel}>
        <CheckBox
          className={styles.checkbox}
          name={regionCode}
          label={
            <span className={styles.details}>
              <span className={styles.title}>{displayName}</span>
              <span className={styles.subtitle}>
                {t('onboarding:followGeographies.countriesCount', {
                  count: countryCount,
                })}
              </span>
            </span>
          }
          checked={state !== 'none'}
          partial={state === 'partial'}
          onChange={onToggle}
        />
      </div>
      {expandable && (
        <Button
          className={styles.chevron}
          variant="empty"
          size="xsmall"
          iconName={isExpanded ? 'ChevronLightUp' : 'ChevronLightDown'}
          onClick={onExpandToggle}
          data-testid={`follow-region-row-chevron-${regionCode}`}
          aria-label={
            isExpanded
              ? t('onboarding:followGeographies.collapseRegion')
              : t('onboarding:followGeographies.expandRegion')
          }
        />
      )}
    </div>
  );
};
